var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M1 4v10c0 .89 1.077 1.337 1.707.707l1.957-1.957H12a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3zm1 0a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v5.75a2 2 0 0 1-2 2H4.664a1 1 0 0 0-.707.293L2 14V4zm6-.5a.69.69 0 0 1 .688.747l-.282 3.38a.408.408 0 0 1-.812 0l-.282-3.38A.69.69 0 0 1 8 3.5zm0 6.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5z" })
  );
});